import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { GetPriceListList } from '../../../store/INV/PriceList/PriceListSlice';
import { useTranslation } from 'react-i18next';

const useGetPriceList = () => {
  const { i18n } = useTranslation();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (PriceList?.length === 0) {
      dispatch(GetPriceListList());
    }
  }, []);

  const { PriceList, loading, error } = useAppSelector(state => state.PriceList);

  const PriceListOptions = useMemo(
    () =>
      PriceList &&
      PriceList?.map(branch => ({
        label: i18n.language === 'en' ? branch.name : branch.name2,
        value: branch.id
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [PriceList]
  );

  return { PriceList, PriceListOptions, loading, error };
};

export default useGetPriceList;
